import { render, staticRenderFns } from "./DupesAreaTable.vue?vue&type=template&id=437fb02a&scoped=true"
import script from "./DupesAreaTable.vue?vue&type=script&lang=js"
export * from "./DupesAreaTable.vue?vue&type=script&lang=js"
import style0 from "./DupesAreaTable.vue?vue&type=style&index=0&id=437fb02a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437fb02a",
  null
  
)

export default component.exports